import { type FC } from 'react';
import styled from 'styled-components';

import { Skeleton, colors } from '@soluto-private/mx-asurion-ui-react';

import { type ParsedStore } from '@service-initiation/tech-care-data-access-store';

import { StoreCard } from './StoreCard';

const Container = styled.div`
  position: relative;
  top: 0; /* In case we'd like to use the css hack to hide google map attribution set this to -16px */
`;

const Stores = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  padding-top: 16px;
`;

const StoreSkeleton = styled(Skeleton)`
  margin-bottom: 12px;
`;

export type DrawerProps = {
  evaluateGeolocation: boolean;
  focusedStore?: ParsedStore;
  handleStoreClick: (selectedStore: ParsedStore) => void;
  isLoading: boolean;
  stores: ParsedStore[];
};

const Drawer: FC<DrawerProps> = ({
  evaluateGeolocation,
  focusedStore,
  handleStoreClick,
  isLoading,
  stores,
}) => {
  const storeLoad = isLoading || evaluateGeolocation;
  return (
    <Container>
      <Stores data-testid="stores-list">
        {stores.map((store, i) =>
          !storeLoad ? (
            <StoreCard
              focusedStore={focusedStore}
              handleStoreClick={handleStoreClick}
              key={store.id}
              store={store}
              storeIndex={i + 1}
              style={i === stores.length - 1 ? {} : { marginBottom: '12px' }}
            />
          ) : (
            <StoreSkeleton height={'100px'} key={i} />
          )
        )}
      </Stores>
    </Container>
  );
};

export default Drawer;
